import axios from "axios";
import config from "../config";
import { DetailsImageResponse } from "./ResponseModels/DetailsImageResponse";
import { FakeAxiosResponse } from "./FakeAxiosResponse";
import ImageDetailsResponseFake from "./json/ImageDetailsResponseFake.json";

export async function GetImageDetailsModel(imageUuid: string) {
  let response = null;
  if (!config.useFakeModels) {
    response = axios
      .get<DetailsImageResponse>(config.getDetailsEndpoint, {
        params: {
          uuid: imageUuid,
        },
      })
      .catch((e) => {
        // TODO manage
        console.error("There was an error!", e);
      });
  } else {
    const responseData = JSON.parse(JSON.stringify(ImageDetailsResponseFake));

    response = FakeAxiosResponse(responseData, 200);
  }

  return response;
}
